import { useContext, useState } from "react";
import { FaAtom, FaFileInvoice, FaUserGraduate, FaUserShield, FaUsers, FaVideo, FaRobot } from "react-icons/fa";
import { HiServerStack } from "react-icons/hi2";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import ListeClients from "components/app/Extranet/ListeClients";
import BddContrat from "components/app/Extranet/BddContrat";
import { AuthContext } from "components/auth/auth-provider";
import Formation from "components/app/Extranet/Formation";
import AssistantChatbot from "components/app/Extranet/AssistantChatbot";
import Column from "components/ui/layout/column/column";
import CabinetManagement from "components/ui/layout/CabinetManagement";

import AdminPage from "pages/extranet/admin";
import InvoicesPage from "pages/extranet/invoices";
import AideVideoPager from "pages/extranet/aide video pager .js";

const ClientsPage = (props) => {
  const context = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [showInvoices, setShowInvoices] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const authContext = useContext(AuthContext);

  let newGuides = authContext.utilisateur_reel?.documents?.guides.filter((documents) => documents.isNew === true).length;
  let newNewsLetters = authContext.utilisateur_reel?.documents?.newsletter.filter((documents) => documents.isNew === true).length;
  let newSupports = authContext.utilisateur_reel?.documents?.supports.filter((documents) => documents.isNew === true).length;
  let totalNew = newGuides + newNewsLetters + newSupports;
    // Handlers pour la gestion du cabinet
  const handlePreferences = () => {
    if (props.handleShowPreferences) {
      props.handleShowPreferences();
    } else {
      console.log('Envoi du message showPreferences...');
      window.top.postMessage({ Action: "showPreferences" }, "*");
    }
  };

  const handleInvoices = () => {
    console.log('Affichage des factures dans le menu...');
    setShowInvoices(true);
    setShowHelp(false);
    setShowAdmin(false);
    // Utiliser setTimeout pour s'assurer que les pages sont mises à jour avant de changer l'index
    setTimeout(() => {
      const pages = getUpdatedPages(true, false, false);
      const invoiceIndex = pages.findIndex(page => page.label === "Factures");
      if (invoiceIndex !== -1) {
        setCurrentPage(invoiceIndex);
      }
    }, 0);
  };

  const handleHelp = () => {
    console.log('Ouverture de l\'aide vidéo MAKO...');
    // Ouvrir le lien YouTube MAKO dans une nouvelle fenêtre
    window.open('https://www.youtube.com/@MAKOLogiciels', '_blank'); // Chaîne YouTube officielle MAKO
  };

  const handleAdmin = () => {
    console.log('Affichage administration dans le menu...');
    setShowAdmin(true);
    setShowInvoices(false);
    setShowHelp(false);
    setTimeout(() => {
      const pages = getUpdatedPages(false, false, true);
      const adminIndex = pages.findIndex(page => page.label === "Administration");
      if (adminIndex !== -1) {
        setCurrentPage(adminIndex);
      }
    }, 0);
  };

  // Fonction helper pour générer les pages avec les états donnés
  const getUpdatedPages = (invoices, help, admin) => {
    let pages = [];
    pages = [
      {
        isTitle: true,
        title: "Extranet",
        subTitle: "Les données du cabinet",
      },
      {
        label: "Clients",
        icon: <FaUsers />,
        content: <ListeClients />,
      },
      {
        label: "Base de données",
        icon: <HiServerStack />,
        content: <BddContrat />,
      },
      {
        label: (
          <>
            <span style={{ paddingLeft: 0 }}>Formation</span>
            <div className={totalNew > 0 ? "badge" : ""}></div>
          </>
        ),
        icon: <FaUserGraduate />,
        content: <Formation />,
      },
      {
        label: "Assistant",
        icon: <FaRobot />,
        content: <AssistantChatbot />,
      },
    ];

    if (invoices) {
      pages.push({
        label: "Factures",
        icon: <FaFileInvoice />,
        content: <InvoicesPage IdCabinet={context.state.IdCabinet} />,
      });
    }

    // L'aide vidéo n'ajoute plus de page car elle ouvre directement YouTube

    if (admin) {
      pages.push({
        label: "Administration",
        icon: <FaAtom />,
        content: <AdminPage AccessDossier={() => setShowAdmin(false)} />,
      });
    }

    pages.push({
      isCabinetManagement: true,
      content: <CabinetManagement 
        onPreferences={handlePreferences}
        onInvoices={handleInvoices}
        onHelp={handleHelp}
        onAdmin={handleAdmin}
        showGoHome={false}
      />,
    });

    return pages;
  };
  
  const handlePages = () => {
    return getUpdatedPages(showInvoices, showHelp, showAdmin);
  };

  return (
    <Pager
      withMenu
      pages={handlePages()}
      page={currentPage}
      onPageChange={(page) => {
        setCurrentPage(page);
      }}
    />
  );
};

export default ClientsPage;
